import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render SCA awards page
 */
const SCAAwardsPage = (): React.ReactElement => {
  const linkClassName = "mb-2 underline font-bold cursor-pointer";

  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="sca-awards-page-component"
    >
      <BlockTitle
        text="Awards"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6"
      />

      <div className="flex flex-col lg:flex-row">
        <ul className="flex-1 list-outside list-disc pl-8 pr-6">
          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-managed-board")}
              target="_blank"
              rel="noreferrer"
            >
              Best Managed Board
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-chief-executive-officer")}
              target="_blank"
              rel="noreferrer"
            >
              Best Chief Executive Officer
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-chief-financial-officer")}
              target="_blank"
              rel="noreferrer"
            >
              Best Chief Financial Officer
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-risk-management")}
              target="_blank"
              rel="noreferrer"
            >
              Best Risk Management
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-investors-relations")}
              target="_blank"
              rel="noreferrer"
            >
              Best Investor Relations
            </a>
          </li>
        </ul>

        <ul className="flex-1 list-outside list-disc pl-8">
          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("best-annual-report")}
              target="_blank"
              rel="noreferrer"
            >
              Best Annual Report
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("special-recognition-award")}
              target="_blank"
              rel="noreferrer"
            >
              Special Recognition Award
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("distinguished-distribution")}
              target="_blank"
              rel="noreferrer"
            >
              Distinguished Contribution to Corporate Governance Award
            </a>
          </li>

          <li className={linkClassName}>
            <a
              href={RouteFactory.scaAwards("special-edition")}
              target="_blank"
              rel="noreferrer"
            >
              The SCA Special Edition 2020/2021
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SCAAwardsPage;
